module.exports = __webpack_public_path__ + "img/trademark-2.7cfd9f68.jpg";